import {
  AppointmentOverview,
  Title,
  DateTimePicker,
  PersonalDataForm,
  Remark,
  ServiceCenterPicker,
} from '@/components';

import router from '@/router';

import validationFlow from '@/validation-flow';

import _ from 'lodash';

import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

export default {
  name: 'step6AppointmentInfoMobileTPP',
  components: {
    [AppointmentOverview.name]: AppointmentOverview,
    [Title.name]: Title,
    [DateTimePicker.name]: DateTimePicker,
    [PersonalDataForm.name]: PersonalDataForm,
    [Remark.name]: Remark,
    [ServiceCenterPicker.name]: ServiceCenterPicker,
  },
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      customerDataRaw: 'getCustomerDataRaw',
      loadingState: 'getLoadingState',
      isValidAppointment: 'getIsValidAppointment',
      appointmentPostObject: 'getAppointmentPostObject',
      appointmet: 'getHasAppointment',
    }),
  },
  methods: {
    ...mapActions('appointment', {
      setAppointmentTpp: 'SET_APPOINTMENT_MOBILE_TPP',
    }),
    ...mapMutations('appointment', {
      setCat: 'SET_CAT',
      setHasApp: 'SET_HASAPPOINTMENT',
    }),
    goToPreviousStep() {
      this.$router.push({
        name: 'step5TireInfo',
      });
    },
    confirmAppointment() {
      const personalDataForm = this.$refs.personalDataForm.$refs.form;
      const personalDataFormTitle = this.$refs.personalDataForm.$refs.formPersonalDataTitle;
      const validPersonalDataFormTitle = personalDataFormTitle.isValid();

      personalDataForm.validate().then((isValid) => {
        if (isValid) {
          if (this.isValidAppointment && validPersonalDataFormTitle && !this.loadingState) {
            this.setCat('tpp');
            this.setAppointmentTpp(this.appointmentPostObject)
              .then(() => {
                this.setHasApp(true);
                validationFlow.validateStep6AppointmentInfo();
              }).catch(() => {
                router.push({
                  name: 'error',
                });
              });
          }
        }
      });
    },
    debounceConfim: _.debounce(function () {
      this.confirmAppointment();
    }, 150),
  },
};
